import { useEffect, useState } from 'react';
import { useWindowWidth } from '@react-hook/window-size';

import { SCROLL_COMPONENT_ID } from '~/config';

import consts from '~/sass/consts.module.scss';

export default function useMobileNavigationScroll(): boolean {
  const [hide, setHide] = useState(false);
  const windowWidth = useWindowWidth();

  useEffect(() => {
    const scrollComponent = document.getElementById(SCROLL_COMPONENT_ID);
    if (scrollComponent) {
      let oldValue = 0;
      let newValue = 0;
      const { height } = scrollComponent.getBoundingClientRect();
      const handleScroll = () => {
        newValue = scrollComponent.scrollTop || 0;
        if (newValue < 1) {
          setHide(false);
        } else if (
          newValue - oldValue > 0 &&
          newValue + height < scrollComponent.scrollHeight // checks if bottom of page was reached
        ) {
          setHide(true);
        } else {
          setHide(false);
        }

        oldValue = newValue;
      };

      if (windowWidth < Number(consts.navigation)) {
        scrollComponent.addEventListener('scroll', handleScroll);
        return () =>
          scrollComponent.removeEventListener('scroll', handleScroll);
      }
      setHide(false);
    }

    return undefined;
  }, [windowWidth]);

  return hide;
}
